export const smartphoneConstants = {
  SMARTPHONE_LIST_REQUEST: 'SMARTPHONE_LIST_REQUEST',
  SMARTPHONE_LIST_SUCCESS: 'SMARTPHONE_LIST_SUCCESS',
  SMARTPHONE_LIST_FAILURE: 'SMARTPHONE_LIST_FAILURE',
  SMARTPHONE_LIST_CHANGED: 'SMARTPHONE_LIST_CHANGED',
  SMARTPHONE_LIST_PAGINATION: 'SMARTPHONE_LIST_PAGINATION',

  SMARTPHONE_LOAD_REQUEST: 'SMARTPHONE_LOAD_REQUEST',
  SMARTPHONE_LOAD_SUCCESS: 'SMARTPHONE_LOAD_SUCCESS',
  SMARTPHONE_LOAD_FAILURE: 'SMARTPHONE_LOAD_FAILURE',

  SMARTPHONE_SAVE_REQUEST: 'SMARTPHONE_SAVE_REQUEST',
  SMARTPHONE_SAVE_SUCCESS: 'SMARTPHONE_SAVE_SUCCESS',
  SMARTPHONE_SAVE_FAILURE: 'SMARTPHONE_SAVE_FAILURE',
};
